import { types } from 'mobx-state-tree';

export const Tap = types.model({
  id: types.integer,
  establishment_id: types.integer,
  identifier: types.string,
  status_code: types.integer,
  archived: types.boolean,
});
